// extracted by mini-css-extract-plugin
export default {"productimgwrap":"V1","productimg":"W1","cartrow":"X1","productinfo":"Y1"};
    if(module.hot) {
      // 1737143664496
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  